import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { clearAllHomeAlertMessage, setHomeAlertMessage } from '../../Redux/slices/ui';

const Checker = ({ user, isLoggedIn }) => {
  const dispatch = useDispatch();
  const [isFirst, setIsFirst] = useState(true);
  const handleRequirePinUpdate = () => {
    dispatch(
      setHomeAlertMessage({
        id: 'requirePinUpdate',
        title: 'update_your_pin',
        message: 'please_update_your_pin',
        link: 'settings/security/update-pin',
        linkMsg: 'update_pin'
      })
    );
  };
  const handleRequirePasswordUpdate = () => {
    dispatch(
      setHomeAlertMessage({
        id: 'requirepasswordUpdate',
        title: 'update_your_password',
        message: 'please_update_your_password',
        link: 'settings/security/update-password',
        linkMsg: 'update_password'
      })
    );
  };

  useEffect(() => {
    if (!isLoggedIn) {
      setIsFirst(true);
      dispatch(clearAllHomeAlertMessage());
    }
  }, [isLoggedIn]);

  useEffect(() => {
    const updateChecker = () => {
      if (user.require_pin_update) {
        handleRequirePinUpdate();
      }
      if (user.require_password_update) {
        handleRequirePasswordUpdate();
      }
      setIsFirst(false);
    };

    if (user && isLoggedIn) {
      if (
        isFirst &&
        user.require_pin_update !== undefined &&
        user.require_password_update !== undefined
      ) {
        updateChecker();
      }
    }
  }, [user?.require_pin_update, user?.require_password_update, isLoggedIn]);

  return null;
};

export default Checker;
